import schema, { generateType } from './Schema';
export const WebPage = generateType(schema.getModel('webPage'));
//# sourceMappingURL=WebPageModel.js.map